module.exports = __webpack_public_path__ + "static/media/chart-pie-alt.6db61f5f.svg";